var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex h-7 items-center justify-between"},[_c('h2',{staticClass:"text-[15px] font-medium leading-[23px] tracking-[-0.2px] text-vanilla-300",attrs:{"id":_vm.headingId}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }